var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 69,
    viewBox: "0 0 57 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5042 69H4.48105C2.00758 69 0 67.0744 0 64.7019V8.80783V4.29829C0 1.9257 2.00758 0 4.48105 0H28.5042H36.4922V1.42193C36.4753 1.56818 36.4668 1.72256 36.4668 1.87695V11.2454V13.6505C36.4668 16.99 39.296 19.7039 42.7775 19.7039H45.2849H55.0517C55.1788 19.7039 55.3143 19.6957 55.4414 19.6876H57V64.7019C57 67.0744 54.9924 69 52.5189 69H47.6059H28.5042ZM27.5979 54.3908H43.2604C44.4293 54.3908 45.3781 53.4807 45.3781 52.3595C45.3781 51.2381 44.4293 50.3281 43.2604 50.3281H27.5894C26.4204 50.3281 25.4717 51.2381 25.4717 52.3595C25.4717 53.4807 26.4289 54.3908 27.5979 54.3908ZM11.9269 44.023H43.2604C44.4293 44.023 45.3781 43.1129 45.3781 41.9917C45.3781 40.8703 44.4293 39.9603 43.2604 39.9603H11.9269C10.7579 39.9603 9.80919 40.8703 9.80919 41.9917C9.80919 43.1129 10.7579 44.023 11.9269 44.023ZM43.2604 28.9505H11.9269C10.7579 28.9505 9.80919 29.8605 9.80919 30.9818C9.80919 32.1031 10.7579 33.0131 11.9269 33.0131H43.2604C44.4293 33.0131 45.3781 32.1031 45.3781 30.9818C45.3781 29.8605 44.4293 28.9505 43.2604 28.9505Z",
    fill: "#9197A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0989 18H42.776C42.7675 18 42.7505 18 42.742 18C40.6839 17.9839 39.017 16.41 39 14.4667C39 14.4587 39 14.4426 39 14.4346V2.79074C39 1.71469 39.9355 1 40.9049 1C41.3727 1 41.8404 1.1606 42.2316 1.53L56.4426 14.9485C57.6332 16.0727 56.7913 18 55.0989 18Z",
    fill: "#9197A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.e78c2c4d93129af088c99c5687f6d25b.svg";
export { ForwardRef as ReactComponent };